import { render, staticRenderFns } from "./EmptyTable.vue?vue&type=template&id=49853aa1"
import script from "./EmptyTable.vue?vue&type=script&lang=js"
export * from "./EmptyTable.vue?vue&type=script&lang=js"
import style0 from "./EmptyTable.vue?vue&type=style&index=0&id=49853aa1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports